import { createSlice } from "@reduxjs/toolkit";

export const LibraryTab = createSlice({
  name: "Library-Tab",
  initialState: {
    value: {
      tabValue: "1",
    },
  },
  reducers: {
    updateTabValue: (state, action) => {
      state.value.tabValue = action?.payload?.tabValue;
    },
  },
});

export const { updateTabValue } = LibraryTab.actions;

export default LibraryTab.reducer;
